import { render, staticRenderFns } from "./tasting-tube-labeled.vue?vue&type=template&id=e0b06b9c"
import script from "./tasting-tube-labeled.vue?vue&type=script&lang=js"
export * from "./tasting-tube-labeled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports